/** @format */

const template = `
<sis-menu-button
  [options]="$ctrl.options"
  [disabled]="$ctrl.disabled"
  [menu-title]="$ctrl.menuTitle"
  [place-left]="$ctrl.placeLeft"
  [button-classes]="$ctrl.buttonClasses"
  [scope]="$ctrl.scope"
  (open-change)="$ctrl.openChange({open: $event})"
  [color]="$ctrl.color || 'secondary'">
</sis-menu-button>
`;
export default template;
